module.exports = __webpack_public_path__ + "img/square-root-variable-solid.81674b41.svg";